import { FormattedMessage } from "react-intl";
import { CourseMaterial } from "../coursesLoader";
import { Book } from "common/api/decimal/methods/course";
import useAccessDuration from "../useAccessDuration";

export default function LicenseDuration({
  courseMaterial,
  className,
}: {
  courseMaterial: CourseMaterial | Book;
  className?: string;
}) {
  const { manageLicense, accessDuration } = courseMaterial;
  const duration = useAccessDuration(courseMaterial);
  if (!duration) {
    return null;
  }
  const expiresAt =
    accessDuration !== 0 && !manageLicense?.isTrialAccess
      ? manageLicense?.expiresAt
      : undefined;

  return (
    <div className={className}>
      {expiresAt ? (
        <FormattedMessage
          defaultMessage={
            "{duration}. Expires on <strong>{expirationDate, date, long}</strong>"
          }
          values={{
            strong: (chunks) => <strong>{chunks}</strong>,
            expirationDate: new Date(expiresAt),
            duration,
          }}
        />
      ) : (
        duration
      )}
    </div>
  );
}
